<template>
  <div  v-if="shouldDisplay(hierarchy)" class="TILE" :class="{ EXPANDED: isSelected}">
    <div class="d-flex SHADOW fd-column" >
      <img
          @click="handleClick"
          class="IMAGE cur-pointer"
          :src="hierarchy.image_url"
          :alt="hierarchy.name + ' service catagory image'"
      />
      <div class="p-y-1 p-x-2" :class="{'bd-b-depot' : isSelected}">
        <div class="h5">
          {{hierarchy.name}}
        </div>
        <div class="d-flex SHOWN-SERVICES fd-column m-b-1">
          <div
              v-for="(service, index) in displayServices"
              :key="index"
              class="cur-pointer"
              @click="$store.commit('homepage/request/setSelectedService', service)"
          >
            {{service.service_display_name}}
          </div>
        </div>
        <span
            class="text-bold"
            @click="handleClick"
            :class="[isSelected ? 'c-depot' : 'c-gray70']"
        >
          {{ numberOfServices }} services
          <vk-icon
              class="CHEVRON cur-pointer c-depot"
              :class="{OPEN : isSelected}"
              name="chevrondown"
              unbounded
          />
        </span>

        <div class="EMPTY" :class="{ ARROW: isSelected}"></div>
      </div>
      <div  v-if="showContent" class="TRAY" >

        <div class="p-b-1">
          <span @click="handleClick" class="d-flex jc-end cur-pointer c-gray70">
            <vk-icon name="close"/>
          </span>
          <span class="h3 c-gray80 text-center">
            {{ hierarchy.name }}
          </span>
          <span class="h6 text-center c-gray80">
            {{ numberOfServices }} services available
          </span>
        </div>
        <div class="TRAY-BODY">
          <div
              v-for="(service, index) in services"
              :key="index"
              class="cur-pointer"
              @click="$store.commit('homepage/request/setSelectedService', service)"
          >
            {{service.service_display_name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'hierarchy-card',
  props: {
    hierarchy: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      showContent: false,
      isSelected: false,
    };
  },

  computed: {

    numberOfServices () {
      return this.hierarchy.services.length || 0;
    },
    services () {
      const { services } = this.hierarchy;
      const sortedServices = services.slice().sort((a, b) => {
        return a.service_display_name.localeCompare(b.service_display_name);
      });
      return sortedServices;
    },
    displayServices () {
      return this.services.slice(0, 3);
    },
  },
  watch: {
    currentIndex (val) {
      if (val !== this.index) {
        this.isSelected = false;
        this.showContent = false;
      }
    },
  },
  methods: {
    handleClick () {
      if (this.currentIndex === -1) {
        this.$emit('handle-click', this.index);
        this.isSelected = true;
        setTimeout(() => {
          this.showContent = true;
        }, 500);
      }
      if (this.currentIndex === this.index) {
        this.$emit('handle-click', this.index);
        this.showContent = false;
        setTimeout(() => {
          this.isSelected = false;
        }, 100);
      }
      if (this.currentIndex !== -1 && this.currentIndex !== this.index) {
        this.$emit('handle-click', this.index);
        setTimeout(() => {
          this.isSelected = true;
        }, 200);
        setTimeout(() => {
          this.showContent = true;
        }, 700);
      }
    },
    shouldDisplay (hierarchy) {
      return hierarchy && hierarchy.services.length > 0 && hierarchy.image_url !== '';
    },
  },
};

</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .IMAGE {
    max-height: 150px;
    align-self: auto;
    max-width:100%;
    overflow: hidden;
    object-fit: cover;
  }
  .TEXT {
    height:37px;
    padding: $unit;
    box-shadow: 0 0 4px 0 $color-gray50;
  }
  .TRAY {
    display: flex;
    flex-direction: column;
    justify-self: center;
    position: absolute;
    width:100%;
    @include mobile-only() {
      max-width: 300px;
    }
    @include tablet() {
      max-width:752px;
    }
    @include desktop() {
      max-width:956px;
    }
    @include wide() {
      max-width:1216px;
    }
    height: 250px;
    margin-top: 325px;
    border: 2px solid $color-depot;
    left: 0;
    right:0;
    padding: 20px 2% 30px 2%;
    margin-left: auto;
    margin-right: auto;
  }
  .TRAY-BODY {
    column-count: 4;
    overflow-y: auto;
    flex-flow: column ;
    word-break: break-word;
    @include tablet-only(){
      column-count: 3;
    }
    @include mobile-only(){
      column-count: 1;
    }
  }
  .SHADOW {
    box-shadow: 0 0 5px 0 rgba( black, 0.20);
    &:hover {
      box-shadow: 0 0 10px 0 rgba( black, 0.40);
    }
  }
  .TILE {
    margin-bottom: 0px;
    transition: 0.6s margin-bottom ease-in-out;
  }
  .TILE.EXPANDED {
    margin-bottom: 340px;
  }
  .EMPTY {
    z-index: -1000;
    transition: z-index 0.5s ease;
  }
  .ARROW {
    padding-top: 18px;
    width:20px;
    height: 20px;
    border: solid 1px $color-depot;
    border-bottom-color: transparent;
    border-right-color: transparent;
    position: relative;
    top: 35px;
    left: 170px;
    background-color: white;
    z-index: 10;
    transform: rotate(45deg);
  }
  .CLOSE-ICON {
    cursor: pointer;
    display: flex;
    justify-content: right;
  }
  .CHEVRON {
    transform: rotate(0deg);
    transition: transform 0.5s ease;
  }
  .CHEVRON.OPEN {
    transform: rotate(180deg);
  }
  .SHOWN-SERVICES {
    white-space: nowrap;
    overflow: hidden;
  }
</style>
